const en_EN = {

            'title':"Qualifications Verification System",
            'preMessage':"Thank you for using the Qualifications Verification System of the Macao Polytechnic University! This system is effective in verifying the qualifications awarded, currently being pursued or ever being pursued by a student. Please fill in the online form below with information provided in relevant testimonials or graduation certificates. For any special situation or request, please feel free to contact the Registry via e-mail (Email: registry@mpu.edu.mo; Tel:+853-85996111/6103).",
            'form.studName' :"Student Name",
            'form.dob' :"Date of Birth (YYYY/MM/DD)",
            'form.studName.placeholder' :"Please Enter Chinese Name or English Name",
            'form.studName.hints' :"",
            'form.dob.placeholder' :"YYYY/MM/DD",
            'form.status':"Type of Document",
            'form.status.current':"Testimonial",
            'form.status.graduate':"Graduation Certificate",
            'form.gradYear':"Year of Graduation (YYYY)",
            'form.gradYear.placeholder':"YYYY",
            'form.qual':"Qualification",
            'form.qual.a':"A",
            'form.qual.b':"B",
            'form.qual.c':"C",
            'form.prog':"Programme of study enrolled",
            'form.certNo':"Testimonial/ Graduation Certificate Ref. No.",
            'form.submit':"Verify",
            'form.modify':"Modify",
            'form.reset':"Reset",
            'form.hints':"*All fields are required",
            'result.title':"RESULT",
            'result.success':"Please be confirmed that the information input matches with our system records.",
            'result.fail':"Please be informed that the information input does not match with our system records. Please try again or contact the Registry for any further assistance.",
            'server.error':"System Error. Please refresh the page and try again.",
            'form.error.required':"The field is required",
            'form.error.isDate':"Invalid date format",
            'form.error.radio.required':"The field is required"
        }
export default en_EN;


// WEBPACK FOOTER //
// ./src/i18n/en_EN.js